import React from "react";
import { ISupervisorAttendanceView } from "../attendance.types";
import StatCards from "../../common/stat-cards/stat-cards";
import TeamAttendanceRateChart from "./team-attendance-rate-chart";
import MonthlyAttendanceChart from "../component/monthly-attendance-chart";
import AttendanceTable from "../component/attendance-table";
import { fetchReporteeAttendance } from "./actions";
import UpcomingTeamLeavesCard from "./upcoming-team-leaves-card";
import TodayStatusSplitChart from "./today-status-split-chart";
import "../../../styles/component/attendance.scss"


const SupervisorAttendanceView: React.FC<ISupervisorAttendanceView> = (props) => {

    return (
        <div className={'supervisor-attendance'}>
            <StatCards data={props.cardData} size={'small'}/>
            <div className={'supervisor-attendance__chart-wrapper top-charts'}>
                <TodayStatusSplitChart data={props.summary} isLoading={props.isLoading}/>
                <TeamAttendanceRateChart data={props.chartData.individualAttendanceRate}
                                         isLoading={props.isLoading}/>
            </div>
            <div className={'supervisor-attendance__chart-wrapper secondary-charts'}>
                <MonthlyAttendanceChart data={props.chartData.monthlyTrend} isLoading={props.isLoading}/>
                <UpcomingTeamLeavesCard data={props.upcomingLeaves} isLoading={props.isLoading}/>
            </div>
            <AttendanceTable
                supervisorId={props.supervisorId}
                showPunchOnClick={true}
                isActionVisible={true}
                fetchAttendanceApi={fetchReporteeAttendance}
            />
        </div>
    );

}


export default SupervisorAttendanceView;
